import useGetResultSolution, { QbQuestionType, QmsExamPaperItemType } from './useGetResultSolution';

export { QbQuestionType };
export type { QmsExamPaperItemType };
export default useGetResultSolution;
